import { Chip } from '@/components/common'
import { useState } from 'react'
import { CategoryChip, categoryChips } from '@/hooks/api/use-categories'
import { cn } from '@/services/utils/cn'

interface ChipSelectProps {
  onFilterChange: (activeChips: CategoryChip[]) => void
  initialChips?: CategoryChip[]
  align?: 'left' | 'center' | 'right'
  className?: string
}

export function ChipSelect({
  onFilterChange,
  initialChips,
  align = 'center',
  className,
}: ChipSelectProps) {
  const [activeChips, setActiveChips] = useState<CategoryChip[]>(
    initialChips || []
  )

  const handleChipClick = (selectedChip: CategoryChip) => {
    const updatedChips = activeChips.some((chip) => chip.id === selectedChip.id)
      ? activeChips.filter((chip) => chip.id !== selectedChip.id)
      : [...activeChips, selectedChip]

    setActiveChips(updatedChips)
    onFilterChange(updatedChips)
  }

  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-2 pl-2',
        align === 'left' && 'justify-start',
        align === 'center' && 'justify-center',
        align === 'right' && 'justify-end',
        className
      )}
    >
      {categoryChips.map((item) => (
        <Chip
          key={item.chipName}
          name={item.chipName}
          activeColor={item.activeColor}
          inactiveColor={item.inactiveColor}
          onClick={() => handleChipClick(item)}
          initiallyActive={activeChips.some((chip) => chip.id === item.id)}
        />
      ))}
    </div>
  )
}
